<template>
  <div class="weContainer q-pa-md" v-html="content"/>
</template>

<script>
import {useQueryStore} from '../stores/QueryStore.js'

export default {
  name: 'webentity',
  props: ['wedata', 'id', 'name', 'height', 'noDataLabel'],

  data() {
    return {
      webentity: null,
      resolvedWedata: this.wedata || null,
      content: "",
    }
  },

  methods: {

    fillPlaceholder() {
      if (this.webentity && this.webentity.content) {
        this.content = this.webentity.content
      }

      if (this.resolvedWedata) {
        Object.keys(this.resolvedWedata).forEach((keyname) => {
          let key = "[[" + keyname + "]]"
          this.content = this.content.replaceAll(key, this.resolvedWedata[keyname])
          //logger.info("keyname:", key, "=", this.wedata[keyname])
        })
      } else {
        let emptymsg = (this.noDataLabel && this.noDataLabel != "") ? this.noDataLabel : this.$t('noWebentityDataFound')
        this.content = "<div>" + emptymsg + "</div>"
      }
    },

    appendScriptElementsToDocument() {
      const el = this.$el
      if (!el) {
        console.warn('weContainer element not found')
        return
      }

      const scriptList = el.getElementsByTagName('script')
      const scriptSourceListDefine = []
      const scriptSourceListUse = []

      for (let i = 0; i < scriptList.length; i++) {
        if (scriptList[i].src) {
          scriptSourceListDefine.push(scriptList[i])
        } else {
          scriptSourceListUse.push(scriptList[i])
        }
      }

      const executeInlineScripts = () => {
        for (let i = 0; i < scriptSourceListUse.length; i++) {
          const code = scriptSourceListUse[i].text
          const newScript = document.createElement('script')
          newScript.setAttribute('type', 'text/javascript')
          newScript.appendChild(document.createTextNode(code))
          document.body.appendChild(newScript)
        }
      }

      if (scriptSourceListDefine.length === 0) {
        executeInlineScripts()
        return
      }

      let loadedCount = 0
      for (let i = 0; i < scriptSourceListDefine.length; i++) {
        const source = scriptSourceListDefine[i].src
        const newScript = document.createElement('script')
        newScript.setAttribute('type', 'text/javascript')
        newScript.src = source
        newScript.addEventListener('load', () => {
          loadedCount++
          if (loadedCount === scriptSourceListDefine.length) {
            executeInlineScripts()
          }
        })
        document.body.appendChild(newScript)
      }
    }

  },

  async mounted() {
    //logger.info("now read webentity with name: ", this.name, ' / id:', this.id)
    // logger.info("wedata: ", this.wedata)

    // wedata aus State lesen (wenn über Router navigiert)
    if (!this.resolvedWedata && history.state?.wedata) {
      this.resolvedWedata = JSON.parse(history.state.wedata)
    }

    const queryStore = useQueryStore()
    if (this.id) {
      this.webentity = await queryStore.webEntityGet({webEntityID: this.id})

    } else if (this.name) {
      this.webentity = await queryStore.webEntityGet({webEntityName: this.name})
    }

    this.fillPlaceholder()
    // logger.info("Webentity Mount Done.", this.webentity)

    await this.$nextTick(() => {
      this.appendScriptElementsToDocument()
    })
  }
}
</script>

<style lang="sass">
.weContainer
  h1
    margin-top: 10px
    padding-top: 0
    line-height: 40px
    font-size: 40px
  user-select: text

</style>
